import { Brand, brands } from '@sfstudios/shapeshifter';
import { getEnvVariable } from './getEnvVariable';

const isBrand = (value: string): value is Brand =>
  (brands as readonly string[]).includes(value);

export const brand: Brand = (() => {
  const brandEnv = getEnvVariable('REACT_APP_BRAND', 'SFAnytime');
  if (!isBrand(brandEnv)) {
    console.warn(`Invalid brand: ${brandEnv}. Available brands: ${brands}`);
    return Brand.SFAnytime;
  }
  return brandEnv;
})();
